// Archivo de constantes relacionadas con la marca (ConsorcioAbierto o Px)

import {APP_ENVIRONMENT} from '@/app.consts';

/**
 * Indica que el ambiente que está corriendo es Properix
 */
export function isProperix() {
  return APP_ENVIRONMENT === 'prod_px';
}

/**
 * Src del logo principal de acuerdo a si es Properix o ConsorcioAbierto
 */
export function getLogoSrc() {
  return require(`@/assets/${isProperix() ? 'logo-Px-negativo.svg' : 'ca-horiz-negativo.svg'}`);
}